export enum PlanningPageTab {
  MeetingsTab,
  SendoutsTab,
  CalendarTab,
}
